import axios from 'axios';

// Direct access to Nager.Date API for client-side holiday fetching
const NAGER_API_URL = 'https://date.nager.at/api/v3';

class HolidayService {
  /**
   * Fetch holidays directly from Nager.Date API (client-side)
   * This allows the app to work offline without backend
   */

  async getAvailableCountries() {
    try {
      const response = await axios.get(`${NAGER_API_URL}/AvailableCountries`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch countries from Nager API:', error);
      // Return default countries if API fails
      return this.getDefaultCountries();
    }
  }

  async getPublicHolidays(countryCode, year) {
    try {
      const response = await axios.get(`${NAGER_API_URL}/PublicHolidays/${year}/${countryCode}`);
      return response.data.map(holiday => ({
        date: holiday.date,
        name: holiday.name,
        localName: holiday.localName,
        countryCode: holiday.countryCode,
        global: holiday.global,
        counties: holiday.counties,
        types: holiday.types
      }));
    } catch (error) {
      console.error(`Failed to fetch holidays for ${countryCode}/${year}:`, error);
      throw error;
    }
  }

  async getPublicHolidaysRange(countryCode, startYear, endYear) {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }

    try {
      const holidayPromises = years.map(year =>
        this.getPublicHolidays(countryCode, year).catch(err => {
          console.warn(`Failed to fetch holidays for ${year}:`, err);
          return []; // Return empty array for failed years
        })
      );

      const results = await Promise.all(holidayPromises);
      return results.flat();
    } catch (error) {
      console.error('Failed to fetch holiday range:', error);
      return [];
    }
  }

  /**
   * Fallback country list if API is unavailable
   */
  getDefaultCountries() {
    return [
      { countryCode: 'IE', name: 'Ireland' },
      { countryCode: 'GB', name: 'United Kingdom' },
      { countryCode: 'US', name: 'United States' },
      { countryCode: 'CA', name: 'Canada' },
      { countryCode: 'AU', name: 'Australia' },
      { countryCode: 'NZ', name: 'New Zealand' },
      { countryCode: 'DE', name: 'Germany' },
      { countryCode: 'FR', name: 'France' },
      { countryCode: 'ES', name: 'Spain' },
      { countryCode: 'IT', name: 'Italy' },
      { countryCode: 'NL', name: 'Netherlands' },
      { countryCode: 'BE', name: 'Belgium' },
      { countryCode: 'SE', name: 'Sweden' },
      { countryCode: 'NO', name: 'Norway' },
      { countryCode: 'DK', name: 'Denmark' },
      { countryCode: 'FI', name: 'Finland' },
      { countryCode: 'PL', name: 'Poland' },
      { countryCode: 'CZ', name: 'Czech Republic' },
      { countryCode: 'AT', name: 'Austria' },
      { countryCode: 'CH', name: 'Switzerland' }
    ];
  }
}

const holidayServiceInstance = new HolidayService();
export default holidayServiceInstance;
